<template>
  <div
    class="dropdown"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <span class="nav-link dropdown-trigger" @click="handleClick"> Books </span>
    <div class="dropdown-menu" :class="{ 'dropdown-open': isOpen }">
      <router-link
        to="/books/thoc"
        class="dropdown-item"
        @click="closeDropdown"
      >
        The House of Cavanaugh
      </router-link>
      <router-link to="/books/tsd" class="dropdown-item" @click="closeDropdown">
        The Sweetheart Deal
      </router-link>
      <router-link
        to="/books/smapoy"
        class="dropdown-item"
        @click="closeDropdown"
      >
        So Much a Part of You
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavDropdown",
  data() {
    return {
      isOpen: false,
      isMobile: false,
    };
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleMouseEnter() {
      // Only open on hover for desktop
      if (!this.isMobile) {
        this.isOpen = true;
      }
    },
    handleMouseLeave() {
      // Only close on mouse leave for desktop
      if (!this.isMobile) {
        this.isOpen = false;
      }
    },
    handleClick(event) {
      // Only toggle on click for mobile
      if (this.isMobile) {
        event.preventDefault();
        this.isOpen = !this.isOpen;
      }
      // On desktop, click does nothing
    },
    closeDropdown() {
      this.isOpen = false;
      // Emit event to close parent menu on mobile
      if (this.isMobile) {
        this.$emit("close-menu");
      }
    },
    handleClickOutside(event) {
      if (this.isMobile && !this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    },
    handleResize() {
      this.checkIfMobile();
      // Close dropdown when switching between mobile/desktop
      this.isOpen = false;
    },
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
}

.dropdown-trigger {
  cursor: pointer;
}

.nav-link {
  text-decoration: none;
  color: white;
  padding: 0.5rem;
}

.nav-link:hover {
  color: var(--main-accent);
  transform: scale(1.05);
}

/* Dropdown (desktop) */
.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;

  min-width: 16rem;
  padding: 0.5rem 0;

  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}

.dropdown-menu.dropdown-open {
  display: block;
}

.dropdown-item {
  display: block;
  padding: 0.5rem 1rem;
  text-decoration: none;
  color: black;
  font-size: 1.1rem;
}

.dropdown-item:hover {
  background-color: var(--main-gray);
}

/* Mobile / tablet */
@media (max-width: 768px) {
  .dropdown {
    width: 100%;
    text-align: center;
  }

  .nav-link {
    width: 100%;
    text-align: center;
    padding: 0.25rem 0;
    font-size: 1.1rem;
  }

  .nav-link:hover {
    color: white;
    transform: scale(1.05);
  }

  .dropdown-trigger {
    display: inline-block;
    width: 100%;
  }

  /* Dropdown behaves like an accordion block */
  .dropdown-menu {
    display: none;
    position: static;
    width: 100%;
    background: #2a3d32;
    box-shadow: none;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height 250ms ease, opacity 200ms ease;
  }

  .dropdown-menu.dropdown-open {
    display: block;
    max-height: 10rem;
    opacity: 1;
    padding: 0.25rem 0;
  }

  .dropdown-item {
    max-width: 100%;
    text-align: center;
    color: white;
    font-size: 1rem;
  }

  .dropdown-item:hover {
    background-color: #243f2f;
  }
}
</style>
